import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['fileName', 'fileXlsx', 'preview', 'form', 'corporation', 'corporationError', 'formButton', 'scheduledMonthContainer', 'scheduledMonthItem', 'fileSizeError']

  static values = { maxFileSizeMb: { type: Number, default: 5 } }

  connect() {
    // 初期表示時に削除ボタンの有効/無効を調整
    this.updateRemoveButtonsState()
    this._currentRequest = null
  }

  onChangeFileUserXlsx(event) {
    const file = event.target.files[0]
    this.fileNameTarget.innerText = file.name

    const maxBytes = this.maxFileSizeMbValue * 1024 * 1024
    if (file.size > maxBytes) {
      this.fileSizeErrorTarget.classList.remove("is-hidden")
      this.fileXlsxTarget.value = null
      this.fileNameTarget.innerText = ""
      this.previewTarget.innerHTML = ""
      this.formButtonTarget.classList.add("is-hidden")
      return
    }
    this.fileSizeErrorTarget.classList.add("is-hidden")

    this.onChangeCorporationSelect(event);
    // onChangeCorporationSelect 内で previewIfReady() が呼ばれるため、ここでは呼ばない
  }

  onClickFileUserXlsx(event) {
    event.stopPropagation()

    this.fileXlsxTarget.value = null
  }

  onChangeCorporationSelect(event){
    if (this.corporationTarget.value == ""){
      this.corporationErrorTarget.classList.remove("is-hidden");
    }else{
      this.corporationErrorTarget.classList.add("is-hidden");
    }
    // 団体変更時にファイルが選択済みならプレビュー再実行
    this.previewIfReady();
  }

  onSubmit(event){
    this.onChangeCorporationSelect(event);
    if(this.corporationTarget.value != ""){
      this.formTarget.submit();
    }
  }

  addScheduledMonth(event){
    const addBtn = event.currentTarget;
    const container = this.scheduledMonthContainerTarget;
    const items = this.scheduledMonthItemTargets;
    const lastItem = items[items.length - 1];
    const clone = lastItem.cloneNode(true);

    // 追加した要素の入力値は空にする
    const input = clone.querySelector('input[name="health_check_list[scheduled_month][]"]');
    if (input) {
      input.value = '';
    }

    container.insertBefore(clone, addBtn);
    this.updateRemoveButtonsState();
  }

  removeScheduledMonth(event){
    const item = event.currentTarget.closest('[data-admin--health-check-lists--new-target="scheduledMonthItem"]');
    if (!item) return;
    if (this.scheduledMonthItemTargets.length <= 1) return; // 最低1つは残す
    item.remove();
    this.updateRemoveButtonsState();
    // 月が減った場合もファイル選択済みならプレビュー再実行
    this.previewIfReady();
  }

  updateRemoveButtonsState(){
    const count = this.scheduledMonthItemTargets.length;
    this.scheduledMonthItemTargets.forEach((item) => {
      const btn = item.querySelector('button[data-action*="removeScheduledMonth"]');
      if (!btn) return;
      if (count <= 1) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
    });
  }

  onChangeScheduledMonth(event){
    // 月の選択変更時にファイルが選択済みならプレビュー再実行
    this.previewIfReady();
  }

  previewIfReady(){
    try{
      if (!this.fileXlsxTarget || !this.fileXlsxTarget.files || this.fileXlsxTarget.files.length === 0){
        return;
      }

      // 進行中のリクエストをキャンセル
      if (this._currentRequest) {
        this._currentRequest.abort()
        this._currentRequest = null
      }

      const controller = new AbortController()
      this._currentRequest = controller

      const formData = new FormData(this.formTarget)
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      fetch('/admin/health_check_lists/preview', {
        method: 'POST',
        body: formData,
        signal: controller.signal,
        headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {}
      })
      .then(response => {
        if (!response.ok) throw new Error('response error')
        return response.text()
      })
      .then(html => {
        this._currentRequest = null
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        this.previewTarget.innerHTML = doc.body.innerHTML
        if (this.previewTarget.querySelector(".error") == null) {
          this.formButtonTarget.classList.remove("is-hidden")
        } else {
          this.formButtonTarget.classList.add("is-hidden")
        }
      })
      .catch(e => {
        if (e.name === 'AbortError') return  // キャンセルは正常
        this._currentRequest = null
        this.previewTarget.innerHTML = "<div class='notification mb-2 is-warning'>エラーが発生しました。アップロードしたファイルを読み込めません。</div>"
      })
    }catch(e){
      // no-op
    }
  }
}
